import React, { useState, useContext } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { GET_WALLPAPERS } from "../GraphQL/Queries";
import { DELETE_WALLPAPER } from "../GraphQL/Mutations";
import {
  Row,
  Col,
  Pagination,
  Tooltip,
  message,
  Card,
  Button,
  Input,
  Empty,
  Modal,
  Select,
} from "antd";
import "antd/dist/antd.css";
import "../Styles/Home.css";
import EditButton from "../Buttons/editButton";
import DeleteButton from "../Buttons/deleteButton";
import AddButton from "../Buttons/addButton";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/auth";
import AddWallpaper from "./AddWallpaper";
import { Options } from "../Constants/Option";
import gql from "graphql-tag";
import { useLazyQuery } from "@apollo/client";

const SEARCH_WALLPAPERS = gql`
  query searchWallpapers($search: String) {
    searchWallpapers(search: $search) {
      id
      image
      title
      category
      description
      username
    }
  }
`;

const { Option } = Select;

const Home = () => {
  const { user } = useContext(AuthContext);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(20);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");

  const [searchWallpaper, { data: searchData }] = useLazyQuery(
    SEARCH_WALLPAPERS,
    {
      fetchPolicy: "cache-and-network",
    }
  );

  const [deleteWallpaper] = useMutation(DELETE_WALLPAPER, {
    refetchQueries: [{ query: GET_WALLPAPERS }],
  });

  const { loading: wallpaperLoading, error, data } = useQuery(GET_WALLPAPERS, {
    fetchPolicy: "cache-and-network",
  });

  if (wallpaperLoading || loading)
    return (
      <Row gutter={[16, 16]}>
        {[...Array(20)].map((_, index) => (
          <Col xs={24} sm={12} md={8} lg={6} key={index}>
            <Card loading />
          </Col>
        ))}
      </Row>
    );

  if (error) return `Error! ${error.message}`;

  function handleChange(page, pageSize) {
    setMinValue(pageSize * (page - 1));
    setMaxValue(pageSize * page);
  }

  function handleSearch(e) {
    setSearch(e.target.value);
  }

  function handleSearchWallpaper() {
    if (search !== "") {
      setLoading(true);
      searchWallpaper({ variables: { search: search } }).finally(() => {
        setLoading(false);
      });
    }
  }

  function handleCategoryChange(value) {
    setSelectedCategory(value);
  }

  const cardData = searchData
    ? searchData.searchWallpapers
    : data.getWallpapers;

  const filteredCardData = selectedCategory
    ? cardData.filter((card) => card.category === selectedCategory)
    : cardData;

  const cardItems = filteredCardData.map((card) => {
    return (
      <Col
        xs={24}
        sm={12}
        md={8}
        lg={6}
        key={card.id}
        style={{ marginBottom: "1.25rem" }}
      >
        <Card
          style={{ width: "100%" }}
          cover={
            <Link to={`/wallpaper/${card.id}`}>
              <img
                src={card.image}
                style={{ height: "12rem", width: "100%" }}
                alt="wallpaper"
              />
            </Link>
          }
        >
          <h4>{card.title}</h4>

          {user && user.username === card.username && (
            <Link to={"/Update/" + card.id}>
              <Tooltip placement="bottom" title={"Edit"}>
                <EditButton />{" "}
              </Tooltip>
            </Link>
          )}
          {user && user.username === card.username && (
            <Tooltip placement="bottom" title={"Delete"}>
              {" "}
              <DeleteButton
                onClick={() => {
                  Modal.confirm({
                    title: "Are you sure you want to delete this wallpaper?",
                    onOk() {
                      deleteWallpaper({ variables: { wallpaperId: card.id } });
                      message.info("Wallpaper Successfully Deleted!");
                    },
                    onCancel() {},
                  });
                }}
              />
            </Tooltip>
          )}
        </Card>
      </Col>
    );
  });

  return (
    <>
      {showModal && (
        <AddWallpaper show={showModal} close={() => setShowModal(false)} />
      )}

      <section>
        {user ? (
          <p>Welcome Back: {user.username}</p>
        ) : (
          <p>Welcome</p>
        )}
        {user ? (
          <h2 className="heading">
            Latest Collection{" "}
            <Tooltip title={"Upload"}>
              <span style={{ float: "right" }}>
                <AddButton onClick={() => setShowModal(true)} />
              </span>
            </Tooltip>
          </h2>
        ) : (
          <h2 className="heading">Latest Collection</h2>
        )}

        <div className="search-bar">
          <Input
            placeholder="Search wallpapers"
            style={{ width: "15.625rem", marginRight: "0.625rem" }}
            suffix={<SearchOutlined />}
            onChange={handleSearch}
          />
          
          <Button
            type="primary"
            className="search-btn"
            onClick={handleSearchWallpaper}
          >
            Search
          </Button>

          <Select
            className="select"
            style={{ width: "10.625rem", marginLeft: "1rem" }}
            placeholder="Filter By Category"
            onChange={handleCategoryChange}
            allowClear
          >
            <Option value="">All</Option>
            {Options.map((option) => (
            <Option value={option} key={option}>
            {option}
             </Option>
               ))}
            </Select>
        </div>
      </section>

      <br></br>
      {cardItems.length ? (
        <>
          <Row gutter={[16, 16]}>{cardItems.slice(minValue, maxValue)}</Row>
          <Pagination
            defaultCurrent={1}
            defaultPageSize={20}
            onChange={handleChange}
            total={cardItems.length}
            showSizeChanger
          />
        </>
      ) : (
        <Empty description="Sorry, we couldn't find any matches." />
      )}
    </>
  );
};

export default Home;
